import { BASE_URL_AUTH } from "../apis/configs/axiosConfig";

//hard code
export const AUTH_CONFIG = {
  domain: "skypad.auth0.com",
  clientId: "dUWXVOhwequp3ZVvJ7n7PCktX6lgqWwD",
  callbackUrl: BASE_URL_AUTH,
  clientName: "sky-marketplace",
  BASE_URL: BASE_URL_AUTH,
};
